import { useMemo } from "react"
import { NONE_VALUE } from "../JourneySelection"
import type { Journeys } from "types/Journeys"
import type { MemberJourneyData } from "types/MemberJourney"

export type InitialJourneyValues = {
  primaryJourney: number
  primaryJourneyPhase: number
}

/**
 * Maps member journey and benefit-enabled journey data to initial form values
 * for primary journey and phase (journeyId and journeyStageId, or NONE_VALUE).
 */
export function useInitialJourneyValues(
  memberJourney: MemberJourneyData | undefined,
  benefitEnabledJourneyData: Journeys | undefined
): InitialJourneyValues {
  return useMemo(() => {
    const routing = memberJourney?.currentMemberJourney?.withInProgressRouting
    if (routing?.journey && benefitEnabledJourneyData) {
      const journey = benefitEnabledJourneyData.find((j) => j.journeyEnumName === routing.journey)

      if (journey) {
        const journeyStage = routing.journeyStage
          ? journey.stages.find((stage) => stage.journeyStageEnumName === routing.journeyStage)
          : null

        return {
          primaryJourney: journey.journeyId,
          primaryJourneyPhase: journeyStage?.journeyStageId ?? NONE_VALUE
        }
      }
    }

    return {
      primaryJourney: NONE_VALUE,
      primaryJourneyPhase: NONE_VALUE
    }
  }, [memberJourney, benefitEnabledJourneyData])
}
